import { Link, Outlet, useLocation } from "react-router-dom";
import { Button } from "@direct-campaign/ui";

export function InfositeLayout() {
  const { pathname } = useLocation();
  const isStrategy = pathname.startsWith("/strategy");

  return (
    <div className="min-h-screen flex flex-col">
      <header className={`border-b sticky top-0 z-50 transition-colors ${isStrategy ? "bg-zinc-900 border-zinc-800" : "bg-white border-border/60"}`}>
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <img src="/logo.png" alt="Direct Campaign" className="h-8 w-auto" />
            <span className={`text-base font-semibold tracking-tight ${isStrategy ? "text-white" : "text-foreground"}`}>
              Direct Campaign
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {/* Platform nav */}
            <div className="flex items-center gap-1">
              <Link
                to="/features"
                className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
                  isStrategy
                    ? "text-zinc-400 hover:text-white hover:bg-zinc-800"
                    : "text-muted-foreground hover:text-foreground hover:bg-accent"
                }`}
              >
                Features
              </Link>
              <Link
                to="/pricing"
                className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
                  isStrategy
                    ? "text-zinc-400 hover:text-white hover:bg-zinc-800"
                    : "text-muted-foreground hover:text-foreground hover:bg-accent"
                }`}
              >
                Pricing
              </Link>
            </div>

            {/* Divider */}
            <div className={`mx-3 h-4 w-px ${isStrategy ? "bg-zinc-700" : "bg-border"}`} />

            {/* Strategy nav */}
            <div className="flex items-center gap-1">
              <Link
                to="/strategy#services"
                className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
                  isStrategy
                    ? "text-zinc-400 hover:text-white hover:bg-zinc-800"
                    : "text-muted-foreground hover:text-foreground hover:bg-accent"
                }`}
              >
                Services
              </Link>
              <Link
                to="/strategy#contact"
                className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
                  isStrategy
                    ? "text-zinc-400 hover:text-white hover:bg-zinc-800"
                    : "text-muted-foreground hover:text-foreground hover:bg-accent"
                }`}
              >
                Work With Us
              </Link>
            </div>
          </nav>

          <div className="flex items-center gap-3">
            <Button variant="ghost" size="sm" className={isStrategy ? "text-zinc-300 hover:text-white hover:bg-zinc-800" : ""} asChild>
              <Link to="/login">Log in</Link>
            </Button>
            <Button size="sm" asChild>
              <Link to="/request-access">Request Access</Link>
            </Button>
          </div>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className={`border-t ${isStrategy ? "bg-zinc-900 border-zinc-800" : "bg-white"}`}>
        <div className="max-w-6xl mx-auto px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2.5">
            <img src="/logo.png" alt="Direct Campaign" className="h-6 w-auto" />
            <span className={`text-sm font-medium ${isStrategy ? "text-zinc-300" : "text-foreground"}`}>
              Direct Campaign
            </span>
          </div>
          <p className={`text-sm ${isStrategy ? "text-zinc-500" : "text-muted-foreground"}`}>
            © {new Date().getFullYear()} Direct Campaign. All rights reserved.
          </p>
          <div className={`flex gap-6 text-sm ${isStrategy ? "text-zinc-500" : "text-muted-foreground"}`}>
            <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">Terms</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
